<template>
    <CommonPopupFrame :changeHeight="100" :closeCompleteAction="closeAction" :isOpen="isOpen" :changeBottom="0" :is-back-press-apply="true">
        <div style="height:20px;">
            <div style="width: 36px; height: 5px; background-color: rgb(217, 217, 217); margin: 5px auto 0px; border-radius: 5px;"></div>
        </div>
        <div style="display: flex; justify-content: center; position: relative; align-items: center; margin-top: 14px;">
            <div style="font-weight: 700; ">{{ mode === MODE.INSERT ? '경력 사항 작성하기' : '경력 사항 수정하기' }}</div>
            <div @click="closeAction" style="position: absolute; top: 50%; transform: translateY(-50%); left: 12px;">
                <img style="width: 40px;" :src="require('@/assets/img/circle_x_btn.png')" alt="">
            </div>
        </div>
        <div style="height: 1px; background-color: #f5f5f5; margin-top: 24px;"></div>
        <div @touchmove.stop="() => {}" style="flex: 1; padding: 0 12px; margin-top: 20px; overflow-y: scroll;">
            <div>
                <div class="title">지도자 경력</div>
                <CountInput v-model="careerLength" :maxNum="50" :placeholder="'코칭 경력을 입력해주세요'"></CountInput>
            </div>
            <!-- <div>
                <div class="title">총 경력</div>
                <CountInput v-model="totalCareerLength" :maxNum="50" :placeholder="'축구 커리어를 몇 년간 이어오셨는지 입력해주세요. ex)12년'"></CountInput>
            </div> -->
            <div style="">
                <div class="title">어떤 팀을 코칭하셨나요?</div>
                <div :class="[ careerList.length >= 2 && i >= 1 ? 'add_style' : '' ]" v-for="each, i in careerList" :key="i + 'career'">
                    <CountInput v-model="each.team_name" :maxNum="20" :placeholder="'팀 이름'"></CountInput>
                    <div style="margin-top: 6px;">
                        <CountInput v-model="each.period" :maxNum="20" :placeholder="'해당 팀을 코칭하신 기간을 입력해주세요.'"></CountInput>
                    </div>
                </div>
                <div style="display: flex; margin-top: 6px;">
                    <div @click="addCareer" class="common_btn">
                        <div style="line-height: 16px;">경력 추가</div>
                        <img style="width: 11px;" :src="require('@/assets/img/plus_gray.png')" alt="">
                    </div>
                </div>
            </div>
            <div style="margin-top: 26px; padding-bottom: 30px;">
                <div class="title">축구선수 경력</div>
                <div :style="{ marginTop: soccerPlayerHistoryList.length >= 2 && i >= 1 ? '15px' : '' }" v-for="each, i in soccerPlayerHistoryList" :key="i + 'history'">
                    <CountInput v-if="i === 0" :isShowCount="false" v-model="each.period" :placeholder="'축구 선수로 활동한 기간을 입력해주세요.'"></CountInput>
                    <div style="margin-top: 15px;">
                        <CountInput :isShowCount="false" v-model="each.team_name" :placeholder="'팀 이름'"></CountInput>
                    </div>
                </div>
                <div style="display: flex; margin-top: 12px;">
                    <div @click="addSoccerrPlayerHistory" class="common_btn">
                        <div style="line-height: 16px;">팀 추가</div>
                        <img style="width: 11px;" :src="require('@/assets/img/plus_gray.png')" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 121px; padding: 0 12px;">
            <div style="line-height: 24px; font-weight: 500; color: #bbbbbb; margin-top: 25px; font-size: 14px; text-align: center;">작성하신 경력은 검토 후 승인되어, 24시간 안에 적용돼요</div>
            <div @click="submit" style="height: 48px; line-height: 48px; text-align: center; font-weight: 500; font-size: 14px; color: #fff; background-color: #210f03; border-radius: 12px; margin-top: 9px;">{{ mode === MODE.INSERT ? '신청하기' : '수정하기' }}</div>
        </div>
    </CommonPopupFrame>
</template>

<script>
import CommonPopupFrame from "@/components/modal/my/CommonPopupFrame";
import CountInput from "@/components/common/CountInput";
import ResponseCode from '@/ResponseCode'

const MODE = {
    INSERT: 'insert',
    UPDATE: 'update'
}

export default {
    name: 'PersonalHistoryForm',
    components: { CommonPopupFrame, CountInput },
    props: {
        mode: {
            type: String,
            default: MODE.INSERT
        },
        completeAction: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            MODE: MODE,
            isOpen : false,
            careerLength: '',
            totalCareerLength: '',
            careerList: [
                { team_name: '', period: '' }
            ],
            soccerPlayerHistoryList: [
                { period: '', team_name: '' }
            ]
        }
    },
    created() {
        if (this.mode === MODE.UPDATE)
        this.getMyCareerHistory()
    },
    methods: {
        closeAction(){
            if(this.isOpen) {
                this.isOpen = false;
                return;
            }
            setTimeout(() => {
                this.$GlobalStore.closeLastModal();
            }, 300)
        },
        addCareer() {
            this.careerList.push(
                { team_name: '', period: '' }
            )
        },
        addSoccerrPlayerHistory() {
            this.soccerPlayerHistoryList.push(
                { period: '', team_name: '' }
            )
        },
        async submit() {
            const formData = new FormData()
            formData.append('mode', this.mode)
            formData.append('career_period', this.careerLength)
            formData.append('coach_period', JSON.stringify(this.careerList))
            formData.append('player_period', JSON.stringify(this.soccerPlayerHistoryList))
            formData.append('total_career_period', this.totalCareerLength)

            const res = await this.$Axios.post('/api/coach/career_history/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.closeAction()
                this.completeAction()
            }
        },
        async getMyCareerHistory() {
            const res = await this.$Axios.get('/api/coach/career_history')

            this.careerLength = res.data.coach_history.career_period
            this.totalCareerLength = res.data.coach_history.total_career_period
            this.careerList = JSON.parse(res.data.coach_history.coach_period)
            this.soccerPlayerHistoryList = JSON.parse(res.data.coach_history.player_period)
        }
    },
    mounted(){
        setTimeout(() => {
            this.isOpen = true;
        }, 100)
    },
}
</script>

<style scoped>
.title {
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 4px;
}

.common_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 9px;
    border-radius: 6px;
    border: 1px solid #000000;
    gap: 6px;
    font-size: 12px;
}

.add_style {
    margin-top: 14px;
    border-top: 1px solid #f5f5f5;
    padding-top: 14px;
}
</style>